import { useEffect, useState } from "react";
import Sidebar from "../../menu/Sidebar";
import Topbar from "../../menu/Topbar";
import Api from "../../Services/Api";
import "./Store.css";
import StoreHeroBanner from "./components/StoreHeroBanner";
import StoreCategoryMenu from "./components/StoreCategoryMenu";
import StoreProductCarousel from "./components/StoreProductCarousel";
import StoreProductCard from "./components/StoreProductCard";
import { defaultStoreCategories, featuredProducts, promotionProducts } from "./data/storeCatalog";

const allCategory = {
  id: "all",
  label: "Todas",
  icon: "",
};

const Store = () => {
  const [menuClose, setMenuClose] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState("all");
  const [categories, setCategories] = useState(defaultStoreCategories);
  const [publicProducts, setPublicProducts] = useState([]);

  const toggleMenu = () => {
    setMenuClose((prev) => !prev);
  };

  useEffect(() => {
    let mounted = true;

    const loadCategories = async () => {
      try {
        const response = await Api.get("/public/store-categories");
        const items = Array.isArray(response?.data?.items) ? response.data.items : [];

        if (!mounted || items.length === 0) return;

        setCategories(
          items.map((item) => ({
            id: item.slug,
            label: item.name,
            description: item.description || "",
            icon: item.icon || "",
          }))
        );
      } catch (err) {
        console.error("Erro ao carregar categorias da store:", err);
      }
    };

    loadCategories();

    return () => {
      mounted = false;
    };
  }, []);

  useEffect(() => {
    let mounted = true;

    const loadProducts = async () => {
      try {
        const response = await Api.get("/public/store-products");
        const items = Array.isArray(response?.data?.items) ? response.data.items : [];
        if (!mounted) return;
        setPublicProducts(items);
      } catch (err) {
        console.error("Erro ao carregar produtos da store:", err);
      }
    };

    loadProducts();

    return () => {
      mounted = false;
    };
  }, []);

  const matchesCategory = (product) =>
    selectedCategory === "all" || product.category === selectedCategory;

  const hasManagedProducts = publicProducts.length > 0;
  const normalizedProducts = hasManagedProducts
    ? publicProducts.map((product) => ({
        ...product,
        category: product.categorySlug,
      }))
    : [];

  const promotionSource = hasManagedProducts
    ? normalizedProducts.filter((product) => product.showInPromotions)
    : promotionProducts;

  const highlightsSource = hasManagedProducts
    ? normalizedProducts.filter((product) => product.showInHighlights)
    : featuredProducts;

  const filteredPromotions = promotionSource.filter(matchesCategory);
  const filteredHighlights = highlightsSource.filter(matchesCategory);
  const storeMenuCategories = [allCategory, ...categories];

  return (
    <div className="app-container">
      <Sidebar close={menuClose} storeActive="active" />

      <main className="main-content">
        <Topbar page="Store / Materiais" onToggleMenu={toggleMenu} />

        <div className="store-page">
          <StoreCategoryMenu
            categories={storeMenuCategories}
            selectedCategory={selectedCategory}
            onSelect={setSelectedCategory}
          />

          <StoreHeroBanner />

          <StoreProductCarousel
            title="Promocoes em destaque"
            eyebrow="Ofertas"
            description="Selecao inicial com condicoes especiais para abastecer sua operacao."
            products={filteredPromotions}
            emptyMessage="Nao ha promocoes nessa categoria agora."
          />

          <section className="store-section-card">
            <div className="store-section-header">
              <div>
                <span className="store-section-eyebrow">Destaques</span>
                <h2>Produtos em destaque</h2>
                <p>Itens mais relevantes para montagem de vitrine, atendimento e divulgacao.</p>
              </div>
            </div>

            {filteredHighlights.length > 0 ? (
              <div className="store-highlight-grid">
                {filteredHighlights.map((product) => (
                  <StoreProductCard key={product.id} product={product} />
                ))}
              </div>
            ) : (
              <div className="store-empty-state">
                Nenhum produto em destaque encontrado para essa categoria.
              </div>
            )}
          </section>
        </div>
      </main>
    </div>
  );
};

export default Store;
